
import getEdition from '~/graphql/queries/getEdition.graphql';

import GwExpander from '~/patterns/molecules/expander/expander.vue';
import GwIcon from '~/patterns/atoms/icon/icon.vue';
import addCurrency from '~/mixins/addCurrency';
import addVatToText from '~/mixins/addVatToText';

export default {
    components: {
        GwExpander,
        GwIcon
    },
    mixins: [addCurrency, addVatToText],
    props: {
        editionId: {
            type: String,
            default: null
        },
        netPrice: {
            type: Number,
            default: 0
        },
        editionPrice: {
            type: Number,
            default: 0
        },
        quantity: {
            type: Number,
            default: 1
        },
        crossSellDiscount: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            edition: null,
            selectedCurrency: null
        };
    },
    computed: {
        price() {
            return this.addCurrency(this.editionPrice, this.selectedCurrency);
        },
    },
    watch: {
        edition() {
            this.$nuxt.$emit('editionUpdate', this.edition);
        }
    },
    created() {
        if (this.editionId) {
            this.getCurrency();
        }
    },
    mounted() {
        if (this.editionId) {
            this.getEditionInfo();
        }
        this.$nuxt.$emit('editionUpdate', this.edition);
    },
    methods: {
        async getEditionInfo() {
            const editionId = this.editionId;
            const site = this.$config.site.siteHandle;

            try {
                await this.$gql.executeQuery(
                    getEdition,
                    { id: editionId, site }
                )
                    .then((response) => {
                        this.edition = response.data.entry;
                    });
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(err);
            }
        },
        formatDate(date) {
            return this.$d(new Date(date), 'dateShort');
        },
        getCurrency() {
            if (process.client) {
                this.selectedCurrency = localStorage.getItem('selectedCurrency') || 'EUR';
            } else {
                this.selectedCurrency = 'EUR';
            }
        },
    }
};
